import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['16px', '16px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const HamburgerIcon = (props) => {
  const size = typeof props.size === 'string' ? sizes[props.size] : props.size;
  const [width, height] = size;
  const svgProps = {
    width,
    height,
    style: Object.assign(
      props.shouldPadding ? { padding: '4px' } : {},
      props.style
    ),
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      {...svgProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        // fill="currentColor"
        // fillRule="evenodd"
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  );
};

HamburgerIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
  style: {},
};

HamburgerIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'middle', 'large', 'huge']),
    PropTypes.array,
  ]),
  shouldPadding: PropTypes.bool,
  style: PropTypes.object,
};

export default HamburgerIcon;
